import { Action } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';
import { getUserDetails } from 'shared/util/utility';
import { LoginState } from '../interface/login';

const initialState: LoginState = {
	userDetails: getUserDetails(),
	accountDetail: {},
	vipLevel: [],
	slipsWin: 0 || null,
	loginModalOpen: false,
	remindModalOpen: false,
	verificationModalOpen: false,
	defaultStake: [],
};

const reducer = (state: LoginState = initialState, action: Action): LoginState => {
	switch (action.type) {
		case actionTypes.BACKGROUND_LOGIN_STATUS:
			return { ...state, backgroundLogin: action.payload };

		case actionTypes.LOGIN_SUCCESS:
			return { ...state, userDetails: action.payload };

		case actionTypes.USER_VERIFICATION_STATUS_SUCCESS:
			return {
				...state,
				accountDetail: action.payload,
			};
		case actionTypes.VIP:
			return {
				...state,
				vipLevel: action.payload,
			};
		case actionTypes.UPDATE_STAKE_VALUES:
			return { ...state, defaultStake: action.payload };
		case actionTypes.WIN_DATA:
			return {
				...state,
				slipsWin: action.payload,
			};
		case actionTypes.SHOW_MODAL:
			return {
				...state,
				loginModalOpen: true,
			};
		case actionTypes.HIDE_MODAL:
			return {
				...state,
				loginModalOpen: false,
			};
		case actionTypes.SHOW_REMIND_MODAL:
			return {
				...state,
				remindModalOpen: true,
			};
		case actionTypes.HIDE_REMIND_MODAL:
			return {
				...state,
				remindModalOpen: false,
			};
		case actionTypes.SHOW_VERIFICATION_MODAL:
			return {
				...state,
				verificationModalOpen: true,
			};
		case actionTypes.HIDE_VERIFICATION_MODAL:
			return {
				...state,
				verificationModalOpen: false,
			};
		default:
			return state;
	}
};

export default reducer;
